import { BUILD_VERSION } from '../generated/buildVersion';

export const BUILD_STAMP_STORAGE_KEY = 'point_build_stamp_seen';

/** yyyyMMddHHmm veya eski yyyyMMddHHmmss */
export function normalizeBuildStamp(value) {
  const digits = String(value || '').replace(/\D/g, '');
  if (digits.length >= 12) return digits.slice(0, 12);
  return digits;
}

export function formatBuildStampDisplay(stamp) {
  const s = normalizeBuildStamp(stamp);
  if (s.length < 12) return String(stamp || '');
  const y = s.slice(0, 4);
  const m = s.slice(4, 6);
  const d = s.slice(6, 8);
  const h = s.slice(8, 10);
  const min = s.slice(10, 12);
  return `${d}.${m}.${y} ${h}:${min}`;
}

export function getLastSeenBuildStamp() {
  try {
    return normalizeBuildStamp(localStorage.getItem(BUILD_STAMP_STORAGE_KEY));
  } catch {
    return '';
  }
}

export function markBuildStampSeen(stamp = BUILD_VERSION) {
  try {
    localStorage.setItem(BUILD_STAMP_STORAGE_KEY, normalizeBuildStamp(stamp));
  } catch {
    /* ignore */
  }
}

export function isBuildStampNew(stamp = BUILD_VERSION) {
  const current = normalizeBuildStamp(stamp);
  if (!current) return false;
  const seen = getLastSeenBuildStamp();
  if (!seen) return true;
  return current > seen;
}

export { BUILD_VERSION };
